import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { CLEANER_AVAILABILITY } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import {LoaderService} from "../common/loadingBar/loader.service";
import { Router } from "@angular/router";


@Injectable()
export class CleanersService extends AuthService{

    private URLCreateCleaner = "manager/cleaner";
    private URLCheckCleanerExists = "api/v1/checkIfCleanerExists/:doc";
    private URLCleanerByName = "manager/cleaner/:name/predict-fullname";
    private URLCleanerByDNI = "manager/cleaner/:doc/predict-document";
    private URLfindCleanerByEmail = "manager/cleaner/:mail/predict-email";
    private URLfindCleanerByPhone = "manager/cleaner/:phone/predict-phone";
    private NAME = ":name";
    private DOC = ":doc";
    private OFFICE = ":office";
    private MAIL = ":mail";
    private PHONE = ":phone";
    constructor(public http: Http, public router: Router, private loaderService: LoaderService) {
        super(http,router);
    }
  
    public findCleanerByName(name: string) {
        let URLCleanerByName = this.URLCleanerByName.replace(this.NAME, name);
        return this.http.get(this.APIURL + URLCleanerByName ,{ headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }

    public checkCleanerExists(doc: string) {
        let URLCheckCleanerExists = this.URLCheckCleanerExists.replace(this.DOC, doc);
        return this.http.get(this.APIURL + URLCheckCleanerExists, { headers: this.headers })
        .map((res: Response) => res.json()["response"]);
    }

    public findCleanerByDNI(doc: string) {
         let URLCleanerByDNI = this.URLCleanerByDNI.replace(this.DOC, doc);
        return this.http.get(this.APIURL + URLCleanerByDNI, { headers: this.headers })
        .map((res: Response) => res.json()["response"]);

    }

    public createCleaner(cleaner: object){
        this.loaderService.show();
        return this.http.post(this.APIURL + this.URLCreateCleaner, cleaner, { headers: this.headers})
       .map((res: Response) => {
           this.loaderService.hide();
           return res.json();
        });
   }

    public findCleanerByEmail(email: string) {
         let URLfindCleanerByEmail = this.URLfindCleanerByEmail.replace(this.MAIL, email);
        return this.http.get(this.APIURL + URLfindCleanerByEmail, { headers: this.headers })
        .map((res: Response) => res.json()["response"]);
    }

    public findCleanerByPhone(phone: string) {
         let URLfindCleanerByPhone = this.URLfindCleanerByPhone.replace(this.PHONE, phone);
        return this.http.get(this.APIURL + URLfindCleanerByPhone, { headers: this.headers })
        .map((res: Response) => res.json()["response"]);
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/cleaners.service.ts